var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  height: 48,
  viewBox: "0 96 960 960",
  width: 48
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M480 620 371 511q-9-9-21-9t-21 9q-9 9-9 21.5t9 21.5l130 130q9 9 21 9t21-9l131-131q9-9 8.5-21t-9.5-21q-9-9-21-9t-21 9L480 620Zm0 356q-82 0-155-31.5t-127.5-86Q143 804 111.5 731T80 576q0-83 31.5-156t86-127Q252 239 325 207.5T480 176q83 0 156 31.5T763 293q54 54 85.5 127T880 576q0 82-31.5 155T763 858.5q-54 54.5-127 86T480 976Z"
})));
export default __webpack_public_path__ + "static/media/fillArrow.5554eed1.svg";
export { SvgComponent as ReactComponent };